import { createFileRoute } from "@tanstack/react-router";
import { TeamScreen } from "@modules/team/views";

export const Route = createFileRoute("/_staff-area/team")({
  staticData: { title: "nav.team" },
  component: TeamScreen,
});
